import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import Search from '../../../components/Search';
import Table from '../../../components/Table';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import { deleteInternal, getInternalList } from '../../../axios/InternalAxios';
import LoadingOverlay from '../../../components/LoadingOverlay';

function InternalList() {
  const breadcrumbItems = [
    { label: 'Dashboard', href: '/' },
    { label: 'Internal' },
  ];

  const [internal, setInternal] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(5);
  const [loading, setLoading] = useState(false);

  const navigation = useNavigate();

  const fetchInternalList = async (keyword, page, limit) => {
    try {
      // setIsLoading(true);
      const result = await getInternalList(keyword, page, limit);
      setInternal(result.data);
      setTotalPages(result.totalPages);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInternalList(searchKeyword, currentPage, limit);
  }, [searchKeyword, currentPage, limit]);

  const handleSearch = (keyword) => {
    setSearchKeyword(keyword);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit);
    setCurrentPage(1);
  };

  const handleEdit = (id) => {
    navigation(`update/${id}`);
  };

  const handleDelete = async (id) => {
    try {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-primary mx-1', // Bootstrap primary button
          denyButton: 'btn btn-danger mx-1', // Bootstrap warning button
          cancelButton: 'btn btn-secondary mx-1', // Bootstrap secondary button
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, cancel!',
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            setLoading(true);
            await deleteInternal(id);
            await fetchInternalList(searchKeyword, currentPage, limit);
            swalWithBootstrapButtons.fire({
              title: 'Deleted!',
              text: 'Your file has been deleted.',
              icon: 'success',
            });
            setLoading(false);
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire({
              title: 'Cancelled',
              text: 'Your imaginary file is safe :)',
              icon: 'error',
            });
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const columnMap = {
    internal_code: 'Internal Code',
    first_name: 'First Name',
    last_name: 'Last Name',
    title: 'Title',
    extension: 'Extension',
    work_phone: 'Work Phone',
    address: 'Address',
    city: 'City',
    state_or_province: 'State or Province',
    postal_code: 'Postal Code',
    country: 'Country',
    email: 'Email',
    phone: 'Phone',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
  };

  return (
    <div>
      <LoadingOverlay show={loading} message="Deleting data..." />
      <Breadcrumb items={breadcrumbItems}></Breadcrumb>
      <div className="card">
        <div className="card-body">
          <div className="table-search-new mb-2">
            <Search onSearch={handleSearch} />
            <div className=""></div>
            <Link className="btn btn-primary rounded-5" to="create">
              <i className="bi bi-plus-circle-dotted"></i>
              <span> New</span>
            </Link>
          </div>
          <Table
            items={internal}
            columnMap={columnMap}
            isLoading={isLoading}
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
            limit={limit}
            onEdit={handleEdit}
            onDelete={handleDelete}
            showEditButton={true}
          />
        </div>
      </div>
    </div>
  );
}

export default InternalList;
